const tr: Record<string, string> = {
  // Navigation
  'nav.features': 'Özellikler',
  'nav.try': 'Dene',
  'nav.download': 'İndir',

  // Hero
  'hero.title1': 'Rüyalarınızın size',
  'hero.title2': 'ne anlattığını',
  'hero.title3': 'keşfedin.',
  'hero.subtitle': 'Bilinçaltınızın sırlarını saniyeler içinde çözün. İslami kaynaklar ve modern yapay zekanın harmanlandığı kişisel rüya rehberinizle güne uyanın.',

  // Features
  'features.badge': 'Özellikler',
  'features.title1': 'Neden',
  'features.title2': 'Hikmet Rüya?',
  'features.subtitle': 'Antik bilgelik ve modern teknolojinin mükemmel uyumu.',
  'features.dreamJournal.title': 'Hiçbir detayı unutmayın',
  'features.dreamJournal.desc': 'Rüyalarınızı anında kaydedin ve zihinsel yolculuğunuzu güvenle saklayın.',
  'features.aiInterpretation.title': 'Derin ve size özel anlamlar',
  'features.aiInterpretation.desc': 'Sadece kelimelere değil, rüyanızın bağlamına odaklanan akıllı rehberlik.',
  'features.nightMode.title': 'Huzurlu bir uykuya hazırlık',
  'features.nightMode.desc': 'Uyumadan önce zihninizi arındıracak özel içeriklerle geceye huzurla adım atın.',
  'features.unlock': 'Rüyalarınızın kapısını açın',

  // Dream Input
  'dreamInput.badge': 'Şimdi Dene',
  'dreamInput.title1': 'Rüyanı',
  'dreamInput.title2': 'Keşfet',
  'dreamInput.placeholder': 'Dün gece ne gördünüz? Tüm detaylarıyla anlatın, birlikte yorumlayalım...',
  'dreamInput.interpret': 'Yorumla',
  'dreamInput.interpreting': 'Yorumlanıyor...',
  'dreamInput.aiTitle': 'Yapay Zeka Yorumu',
  'dreamInput.notDreamTitle': 'Bilgilendirme',
  'dreamInput.notDreamWarning': 'Merhaba! Ben rüyalarınızı İslami kaynaklara göre yorumlayan bir yapay zekayım. 🌙 Lütfen gördüğünüz bir rüyayı anlatın, sizin için en güzel şekilde yorumlayayım.',
  'dreamInput.sources': '📚 Kaynaklar:',
  'dreamInput.seeMore': '🔓 Tam Yorumu Görmek İçin Tıklayın',
  'dreamInput.unlockFull': 'Uygulamaya giriş yaparak yorumun tamamını ve daha fazlasını keşfedin.',
  'dreamInput.error': 'Yorum alınırken bir hata oluştu. Lütfen tekrar deneyin.',
  'dreamInput.authRequired': 'Rüya yorumu için giriş yapmanız gerekiyor.',
  'dreamInput.newDream': '✨ Yeni Rüya Yaz',

  // Ticker
  'ticker.lucidDreaming': 'Lucid Rüya',
  'ticker.psychology': 'Psikoloji',
  'ticker.astrology': 'Astroloji',
  'ticker.symbolAnalysis': 'Sembol Analizi',
  'ticker.dreamJournal': 'Rüya Günlüğü',
  'ticker.aiInsights': 'Yapay Zeka',
  'ticker.sleepPatterns': 'Uyku Düzeni',
  'ticker.subconscious': 'Bilinçaltı',
  'ticker.review1': 'Sürekli uçurumdan düştüğümü görüyordum. Yorumdan sonra hayatımdaki stres kaynağıyla yüzleştim. İnanılmaz.',
  'ticker.review2': 'Annemin rüyama girmesi beni hep huzursuz ederdi. Burada anlamını öğrenince çok rahatladım.',
  'ticker.review3': 'Aynı kabusu aylarca gördüm. İlk yorumda bile derinde ne olduğunu fark ettim.',
  'ticker.review4': 'Sabah uyandığımda rüyamı hemen yazıyorum. Birkaç haftadır kendimi daha iyi tanıyorum.',
  'ticker.review5': 'İslami kaynaklara dayalı olması benim için çok değerli. Hem geleneksel hem modern.',

  // Footer
  'footer.title': 'Daha Derin Rüya Görmeye Hazır mısınız?',
  'footer.subtitle': "Hikmet Rüya'yı indirin ve bu gece bilinçaltına yolculuğunuza başlayın.",
  'footer.scanToDownload': 'İndirmek için Tarayın',
  'footer.startJourney': 'Sen de Aramıza Katıl İlmîni Arttır',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.terms': 'Kullanım Koşulları',
  'footer.deleteAccount': 'Hesabımı Sil',
  'footer.contact': 'İletişim',
  'footer.rights': '© 2026 Hikmet Rüya. Tüm hakları saklıdır.',

  // Contact Dialog
  'contact.title': 'İletişim',
  'contact.company': 'Uygulama',
  'contact.email': 'E-posta',
  'contact.description': 'Sorularınız, önerileriniz veya geri bildirimleriniz için bize ulaşmaktan çekinmeyin. En kısa sürede size dönüş yapacağız.',

  // Privacy Policy Dialog
  'privacy.title': 'Gizlilik Politikası',
  'privacy.lastUpdated': 'Son Güncelleme Tarihi: 30.04.2026',
  'privacy.intro': 'Hikmet Rüya ("Uygulama", "Biz") olarak kullanıcılarımızın gizliliğini korumayı ve kişisel verilerini güvenle saklamayı taahhüt ediyoruz.',
  'privacy.acceptance': 'Uygulamayı indirerek veya kullanarak, bu politikanın şartlarını kabul etmiş sayılırsınız.',
  'privacy.section1.title': '1. TOPLANAN VERİLER',
  'privacy.section1a.title': 'A. Sizin Sağladığınız Bilgiler:',
  'privacy.section1a.item1.label': 'Hesap Bilgileri:',
  'privacy.section1a.item1.text': 'Kayıt olurken kullandığınız e-posta adresi, ad-soyad (opsiyonel) veya sosyal medya giriş kimlikleri.',
  'privacy.section1a.item2.label': 'Rüya İçerikleri ve Günlükler:',
  'privacy.section1a.item2.text': '"Rüya Ekle" veya "Rüya Günlüğüm" özellikleri kapsamında sisteme metin veya sesli olarak girdiğiniz rüya anlatımları.',
  'privacy.section1a.item3.label': 'Kişiselleştirme Verileri:',
  'privacy.section1a.item3.text': 'Rüya yorumlarının daha isabetli olması amacıyla gönüllü olarak paylaştığınız medeni durum, yaş, cinsiyet veya çalışma durumu bilgileri.',
  'privacy.section1a.item4.label': 'İletişim Talepleri:',
  'privacy.section1a.item4.text': 'Destek hattımızla paylaştığınız geri bildirimler ve hata raporları.',
  'privacy.section1b.title': 'B. Otomatik Toplanan Teknik Veriler:',
  'privacy.section1b.item1.label': 'Cihaz Bilgileri:',
  'privacy.section1b.item1.text': 'Cihaz modeli, işletim sistemi sürümü (iOS/Android), ekran çözünürlüğü, tercih edilen dil.',
  'privacy.section1b.item2.label': 'Kullanım Verileri:',
  'privacy.section1b.item2.text': 'Uygulama içi oturum süreleri, tıklanan butonlar, özellik kullanım sıklığı.',
  'privacy.section1b.item3.label': 'Konum Bilgisi:',
  'privacy.section1b.item3.text': 'Yalnızca "Namaz Vakitleri" özelliğinin çalışması için gerekli olan il/ilçe bazlı yaklaşık konum verisi.',
  'privacy.section2.title': '2. VERİLERİN İŞLENME AMACI',
  'privacy.section2.item1': 'Yapay zekâ destekli rüya yorumlarını oluşturmak ve size sunmak.',
  'privacy.section2.item2': 'Eski rüyalarınızı "Rüya Günlüğüm" bölümünde tarihçeli olarak saklamak.',
  'privacy.section2.item3': 'Namaz vakitlerini bulunduğunuz lokasyona göre doğru hesaplamak.',
  'privacy.section2.item4': 'Uygulama güvenliğini sağlamak ve teknik hataları gidermek.',
  'privacy.section2.item5': 'Yasal yükümlülüklerimizi yerine getirmek.',
  'privacy.section3.title': '3. VERİ PAYLAŞIMI VE ÜÇÜNCÜ TARAFLAR',
  'privacy.section3.item1': 'Girdiğiniz rüya metinleri, yorumlanmak üzere anonimleştirilmiş şekilde işlenir.',
  'privacy.section3.item2': 'Kullanıcı veritabanı, kimlik doğrulama ve rüya kayıtlarınızın güvenli bulut depolamasında tutulması için kullanılır.',
  'privacy.section3.item3': 'Uygulama içi satın alma ve güvenli giriş işlemleri için kullanılır.',
  'privacy.section3.item4.label': 'Yasal Merciler:',
  'privacy.section3.item4.text': 'Mahkeme kararı veya yasal zorunluluk olması durumunda resmi makamlarla paylaşılabilir.',
  'privacy.section4.title': '4. VERİ GÜVENLİĞİ VE SAKLAMA',
  'privacy.section4.item1.label': 'Güvenlik:',
  'privacy.section4.item1.text': 'Verileriniz TLS/SSL ve şifreleme yöntemleri ile korunur.',
  'privacy.section4.item2.label': 'Saklama Süresi:',
  'privacy.section4.item2.text': 'Rüya kayıtlarınız hesabınızı silmediğiniz sürece saklanır.',
  'privacy.section4.item3.label': 'Hesap Silme:',
  'privacy.section4.item3.text': 'Hesabınızı sildiğinizde tüm verileriniz 72 saat içinde kalıcı olarak silinir.',
  'privacy.section5.title': '5. KULLANICI HAKLARI (KVKK m.11)',
  'privacy.section5.item1': 'Verilerinizin işlenip işlenmediğini öğrenme.',
  'privacy.section5.item2': 'Verilerinizin silinmesini veya yok edilmesini talep etme.',
  'privacy.section5.item3': 'Verilerinizin düzeltilmesini isteme.',
  'privacy.section5.item4': 'Aleyhinize çıkan bir sonuca itiraz etme.',
  'privacy.section5.contact': 'İletişim: info@ruyahikmeti.com (30 gün içinde yanıt)',
  'privacy.section6.title': '6. ÇOCUKLARIN GİZLİLİĞİ',
  'privacy.section6.text': 'Bu uygulama 13 yaşından küçüklerin kullanımına yönelik değildir.',
  'privacy.section7.title': '7. İLETİŞİM',
  'privacy.section7.company': 'Uygulama:',
  'privacy.section7.emailLabel': 'E-posta:',

  // Terms of Service Dialog
  'terms.title': 'Kullanım Koşulları',
  'terms.lastUpdated': 'Son Güncelleme Tarihi: 30.04.2026',
  'terms.intro': 'Bu Kullanım Koşulları, Hikmet Rüya uygulamasını ("Uygulama") kullanımınızı düzenler. Uygulamayı indirerek, hesap oluşturarak veya kullanarak bu koşulları kabul etmiş olursunuz.',
  'terms.section1.title': '1. HİZMETİN TANIMI',
  'terms.section1.text': 'Hikmet Rüya, kullanıcıların rüyalarını kaydedebileceği ve İslami kaynaklara dayalı yapay zekâ destekli yorumlar alabileceği mobil bir uygulamadır. Sunulan yorumlar bilgilendirme amaçlıdır ve dini, tıbbi veya psikolojik bir tavsiye yerine geçmez.',
  'terms.section2.title': '2. KULLANICI HESABI',
  'terms.section2.item1': 'Hesap oluşturmak için 13 yaşını doldurmuş olmanız gerekir.',
  'terms.section2.item2': 'Hesap bilgilerinizin gizliliğinden ve hesabınız üzerinden gerçekleştirilen tüm işlemlerden siz sorumlusunuz.',
  'terms.section2.item3': 'Yanlış veya yanıltıcı bilgi vermemeniz gerekmektedir.',
  'terms.section3.title': '3. KABUL EDİLEBİLİR KULLANIM',
  'terms.section3.intro': 'Uygulamayı aşağıdaki amaçlarla kullanmamayı kabul edersiniz:',
  'terms.section3.item1': 'Yasadışı, zararlı, tehditkâr, taciz edici veya başka bir şekilde uygunsuz içerik göndermek.',
  'terms.section3.item2': 'Başkalarının fikri mülkiyet haklarını ihlal etmek.',
  'terms.section3.item3': 'Uygulamanın güvenliğini tehlikeye atmak veya tersine mühendislik yapmak.',
  'terms.section3.item4': 'Otomatik araçlar (bot, scraper) ile sisteme erişmek.',
  'terms.section4.title': '4. FİKRİ MÜLKİYET',
  'terms.section4.text': 'Uygulamadaki tüm metin, grafik, logo, simge, görsel, yazılım kodu ve veriler Hikmet Rüya\'ya aittir ve telif hakkı, marka ve diğer fikri mülkiyet yasaları tarafından korunmaktadır. Yazılı izin olmaksızın kopyalanamaz, dağıtılamaz veya değiştirilemez.',
  'terms.section5.title': '5. KULLANICI İÇERİĞİ',
  'terms.section5.text': 'Uygulamaya girdiğiniz rüya metinleri size aittir. Ancak yapay zekâ yorumunu sağlamak ve hizmeti sürdürmek amacıyla bu içerikleri işlememize izin vermiş olursunuz. İçerikleriniz Gizlilik Politikamıza uygun şekilde işlenir.',
  'terms.section6.title': '6. ABONELİK VE ÖDEMELER',
  'terms.section6.text': 'Uygulamanın bazı özellikleri ücretli abonelik gerektirir. Abonelikler Apple App Store veya Google Play hesabınız üzerinden yönetilir. Aboneliğiniz, mevcut dönemin sonundan en az 24 saat önce iptal edilmediği takdirde otomatik olarak yenilenir. İade talepleri ilgili platformun politikalarına tabidir.',
  'terms.section7.title': '7. SORUMLULUK REDDİ',
  'terms.section7.text': 'Hikmet Rüya yorumları yalnızca bilgilendirme ve manevi rehberlik amacıyla sunulur. Profesyonel tıbbi, psikolojik veya dini tavsiye yerine geçmez. Uygulama "olduğu gibi" sunulmakta olup kesintisiz veya hatasız çalışacağına dair açık veya zımni bir garanti verilmez.',
  'terms.section8.title': '8. SORUMLULUĞUN SINIRLANDIRILMASI',
  'terms.section8.text': 'Yürürlükteki yasaların izin verdiği azami ölçüde, Hikmet Rüya, uygulamanın kullanımından doğan dolaylı, arızi, özel veya sonuç olarak ortaya çıkan zararlardan sorumlu tutulamaz.',
  'terms.section9.title': '9. FESİH',
  'terms.section9.text': 'Bu Koşulları ihlal etmeniz halinde hesabınızı önceden bildirimde bulunmaksızın askıya alma veya kapatma hakkımız saklıdır. Hesabınızı dilediğiniz zaman uygulama içinden veya info@ruyahikmeti.com adresine talep göndererek silebilirsiniz.',
  'terms.section10.title': '10. DEĞİŞİKLİKLER',
  'terms.section10.text': 'Bu Koşulları zaman zaman güncelleyebiliriz. Önemli değişiklikler uygulama içinden veya e-posta ile bildirilir. Güncelleme sonrası uygulamayı kullanmaya devam etmeniz yeni Koşulları kabul ettiğiniz anlamına gelir.',
  'terms.section11.title': '11. UYGULANACAK HUKUK',
  'terms.section11.text': 'Bu Koşullar Türkiye Cumhuriyeti yasalarına tabidir. Doğacak uyuşmazlıklarda İstanbul Mahkemeleri ve İcra Daireleri yetkilidir.',
  'terms.section12.title': '12. İLETİŞİM',
  'terms.section12.text': 'Sorularınız için: info@ruyahikmeti.com',

  // Delete Account Dialog
  'delete.title': 'Hesabımı Sil',
  'delete.intro': 'Hesabınızı ve tüm ilgili verilerinizi (rüya kayıtları, profil bilgileri, ayarlar) kalıcı olarak silebilirsiniz. Bu işlem geri alınamaz.',
  'delete.method1.title': 'Yöntem 1: Uygulama İçinden (Önerilen)',
  'delete.method1.step1': 'Uygulamayı açın ve giriş yapın.',
  'delete.method1.step2': 'Profil > Ayarlar > Hesap menüsüne gidin.',
  'delete.method1.step3': '"Hesabımı Sil" seçeneğine dokunun.',
  'delete.method1.step4': 'Onayladıktan sonra hesabınız ve tüm verileriniz 72 saat içinde kalıcı olarak silinir.',
  'delete.method2.title': 'Yöntem 2: E-posta Talebi',
  'delete.method2.text': 'Uygulamaya erişiminiz yoksa, hesabınızla ilişkili e-posta adresinden aşağıdaki bilgileri içeren bir mail gönderin:',
  'delete.method2.item1': 'Konu: "Hesap Silme Talebi"',
  'delete.method2.item2': 'Hesabınıza ait e-posta adresi',
  'delete.method2.item3': 'Kısa bir doğrulama notu',
  'delete.method2.email': 'Gönderilecek adres: info@ruyahikmeti.com',
  'delete.method2.timeline': 'Talebinizi aldıktan sonra 72 saat içinde hesabınız silinir ve onay mailı gönderilir.',
  'delete.deletedData.title': 'Silinecek Veriler',
  'delete.deletedData.item1': 'Hesap bilgileri (e-posta, ad-soyad)',
  'delete.deletedData.item2': 'Tüm rüya kayıtları ve günlük girişleri',
  'delete.deletedData.item3': 'Yorum geçmişi ve favoriler',
  'delete.deletedData.item4': 'Ayarlar ve tercihler',
  'delete.retainedData.title': 'Saklanan Veriler',
  'delete.retainedData.text': 'Yasal zorunluluklar (vergi, fatura, yasal yazışmalar) gereği bazı işlem kayıtları KVKK m.5/2(ç) uyarınca anonimleştirilmiş olarak saklanabilir.',
  'delete.contactButton': 'Silme Talebi Gönder',

  // Phone Mockup
  'phone.dream': 'Rüyamda gökyüzünde parlak bir ay gördüm ve yıldızlar dans ediyordu...',
  'phone.aiLabel': 'AI Yorumu',
  'phone.aiResponse': 'Ay görmek ilim ve irfanın temsilcisidir. Hayatınıza girecek bir rehberin habercisi...',

  // Sample Interpretations
  'dreamInterpretation1': 'Rüyanızda gördüğünüz su, manevi arınma ve yenilenmeyi simgeler. İbn-i Sirin\'e göre berrak su görmek hayırlı haberlerin müjdecisidir. Bilinçaltınız size iç huzur arayışınızı hatırlatıyor.',
  'dreamInterpretation2': 'Rüyada uçmak, manevi yükselişin ve özgürlük arayışının sembolüdür. Karşılaştığınız engelleri aşma gücünüz olduğunu gösterir. İç dünyanız size sınırlarınızı aşabileceğinizi fısıldıyor.',
  'dreamInterpretation3': 'Gördüğünüz ay, İslami kaynaklara göre ilim ve irfanın temsilcisidir. Hayatınıza girecek bir rehberin veya bilge kişinin habercisi olabilir. Kalbinizi nurla dolduracak bir dönem sizi bekliyor.',

  // Legal pages
  'legal.openAsPage': 'Tam sayfa olarak aç',
  'legal.backHome': 'Ana sayfaya dön',
};

export default tr;
